import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule }    from '@angular/forms';

/** AngularMaterial **/


import { SalarioMinimoComponent } from './salario-minimo.component';
import { SalarioMinimoRoutingModule } from './salario-minimo.routes';

import { FiltroDinamicoModule }  from 'unb-questionario-componente';
import { MatButtonModule, MatInputModule } from '@angular/material';
import { EstudoService } from '../estudo/estudo.service';

/**
Lista de Componentes do MaterialDesign (importar somento o q for usar)
MaterialModule, MdAutocompleteModule, MdCheckboxModule, MdInputModule, MdRadioModule, MdSelectModule, MdSliderModule, MdSlideToggleModule, MdMenuModule, MdSidenavModule, MdToolbarModule, MdListModule, MdGridListModule, MdCardModule, MdTabsModule, MdButtonModule, MdButtonToggleModule, MdChipsModule, MdIconModule, MdProgressSpinnerModule, MdDialogModule, MdTooltipModule, MdSnackBarModule
**/

@NgModule({
    declarations: [
      SalarioMinimoComponent,
    ],
    exports: [
      SalarioMinimoComponent,
    ],
    imports: [
      CommonModule,
      FormsModule,
      MatButtonModule, MatInputModule,
      FiltroDinamicoModule,
      SalarioMinimoRoutingModule
    ],
    providers: [
      EstudoService
    ]
})
export class SalarioMinimoModule {
}
